import { render } from "./ReportsIncomesReceivables.vue?vue&type=template&id=1e4f3770"
import script from "./ReportsIncomesReceivables.vue?vue&type=script&lang=js"
export * from "./ReportsIncomesReceivables.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__